<template>
  <div class="backdrop" v-if="!cookies && getCookiesAdviseTrans">
    <div class="cookies">
      <h1 class="cookies-title">{{ getCookiesAdviseTrans.title }}</h1>
      <p class="cookies-info">{{ getCookiesAdviseTrans.p }}</p>
      <a class="cookies-link" @click="openCookies">{{ getCookiesAdviseTrans.cookies_policy_link }}</a>
      <div class="cookies-buttons">
        <button class="cookies-btn btn-black" @click="acceptCookies">{{ getCookiesAdviseTrans.button_accept }}</button>
        <button class="cookies-btn" @click="configureCookies">{{ getCookiesAdviseTrans.cookies_config_link }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'Cookies',
  computed: {
    ...mapState(['cookies']),
    ...mapGetters(['getCookiesAdviseTrans'])
  },
  methods: {
    ...mapMutations(['setCookies']),
    acceptCookies () {
      this.setCookies(true)
      localStorage.setItem('coockieAgreed', true)
    },
    configureCookies () {
      this.$vfm.show('cookiesModal')
    },
    openCookies () {
      window.open(`https://participa.barmanagerapp.com/keler/#/${this.$route.params.alias_url}/cookies_policy`, '_blank')
    }
  },
  created () {
    if (JSON.parse(localStorage.getItem('coockieAgreed'))) {
      this.setCookies(true)
    }
  }
}
</script>

<style scoped>
.backdrop {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
.cookies {
  --tw-bg-opacity: 1;
  background-color: rgba(246, 246, 246, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
}
.cookies-title {
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.75rem;
  margin-bottom: 1.5rem;
}
.cookies-info {
  font-size: 0.75rem;
  line-height: 1rem;
  text-align: center;
}
.cookies-link {
  cursor: pointer;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: 0.5rem;
  text-align: center;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
.cookies-buttons {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.cookies-btn {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  width: 100%;
}
.cookies-btn:hover {
  opacity: 0.8;
}
.cookies-btn:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.cookies-btn:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.btn-black {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
</style>
